import Hero from "./components/Hero";
import Benefits from "./components/Benefits";
import Categories from "./components/Categories";
import Selection from "./components/Selection";
import EditorialBanner from "./components/EditorialBanner";
import LooksMoments from "./components/LooksMoments";
import NewArrivals from "./components/NewArrivals";
import Support from "./components/Support";
import BrandStory from "./components/BrandStory";
import Inspirations from "./components/Inspirations";
import VelloraCall from "./components/VelloraCall";

export default function Home() {
  return (
    <>
      <Hero />
      <Benefits />
      <Categories />
      <Selection />
      <EditorialBanner />
      <LooksMoments />
      <NewArrivals />
      <Support />
      <BrandStory />
      <Inspirations />
      <VelloraCall />
    </>
  );
}